/**
 * @author Supraja Ramesh
 */
import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../../src/settings/shared/constants"
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getSummary(projectId) {
    return axiosClient({
        url: constants.api.dashboard.getSummary + '?projectId=' + projectId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function getAnalytics(projectId) {
    return axiosClient({
        url: constants.api.dashboard.getAnalytics + '?projectId=' + projectId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function getExecutionDetail(executionId, agentId) {
return axiosClient({
url: `${constants.api.dashboard.getExecutionDetail}${executionId}?agentId=${agentId}`,
method: HTTP_METHODS.GET,
headers: _constructHeader(),
data: ''
    })
}

function getTopAgents(projectId, page = 0, size = 20) {
    return axiosClient({
        url: constants.api.dashboard.getTopAgents + '?projectId=' + projectId + '&page=' + page + '&size=' + size,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function getExecutionsList(projectId, page = 0, size = 20) {
    return axiosClient({
        url: constants.api.dashboard.getExecutionsList + '?projectId=' + projectId + '&page=' + page + '&size=' + size,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

const EvaluationDashboardService = {
    getSummary,
    getAnalytics,
    getExecutionDetail,
    getTopAgents,
    getExecutionsList
}
export default EvaluationDashboardService;